var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_838_10315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.75C12.4047 1.75 12.5531 1.81146 12.6625 1.92085C12.7719 2.03025 12.8333 2.17862 12.8333 2.33333V11.6667C12.8333 11.8214 12.7719 11.9697 12.6625 12.0791C12.5531 12.1885 12.4047 12.25 12.25 12.25H1.74999C1.59528 12.25 1.44691 12.1885 1.33751 12.0791C1.22811 11.9697 1.16666 11.8214 1.16666 11.6667V2.33333C1.16666 2.17862 1.22811 2.03025 1.33751 1.92085C1.44691 1.81146 1.59528 1.75 1.74999 1.75H12.25ZM2.33332 5.83333V11.0833H11.6667V5.83333H2.33332ZM2.33332 4.66667H11.6667V2.91667H2.33332V4.66667Z",
    fill: "#2D2F34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_838_10315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.05f1afccf9e7a27a3b23c664c5fba789.svg";
export { ForwardRef as ReactComponent };